import {Spinner} from '@primer/react'
import {Dialog} from '@primer/react/experimental'
import {useRef} from 'react'
import {NewMarkdownViewer} from '@github-ui/markdown-viewer/NewMarkdownViewer'
import type {SafeHTMLString} from '@github-ui/safe-html'

type OverviewSidePanelProps = {
  bodyHtml: SafeHTMLString
  isLoading: boolean
  onClose: () => void
}

/**
 * Renders the overview side panel for pull requests
 */
export function OverviewSidePanel({bodyHtml, isLoading, onClose}: OverviewSidePanelProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null)
  const toggleSidesheetRef = useRef<HTMLButtonElement>(null)

  // Check if this is the empty description state by looking for the "No description provided." text
  const isEmptyDescription = bodyHtml.includes('No description provided.')

  return (
    <Dialog
      title="Overview"
      initialFocusRef={closeButtonRef}
      position={{narrow: 'fullscreen', regular: 'right', wide: 'right'}}
      returnFocusRef={toggleSidesheetRef}
      onClose={onClose}
    >
      {isLoading ? (
        <div className="d-flex flex-justify-center">
          <Spinner />
        </div>
      ) : (
        <NewMarkdownViewer verifiedHTML={bodyHtml} className={isEmptyDescription ? 'fgColor-muted' : undefined} />
      )}
    </Dialog>
  )
}
